import clsx from 'clsx';
import React from 'react';

import { kLabelColumnWidth } from '@fragment/ui/src/components/Payments/LayoutRow';

import { RoleColorDot } from './RoleColorDot';

type Props = {
  externalId: string;
  role?: string;
  onClick?: (externalId: string) => void;
  /** Additional classes applied to the outer cell (e.g. `bg-negative` on hover). */
  className?: string;
  /** Align cell vertically. Defaults to centered for single-line rows. */
  align?: 'start' | 'center';
  /** Render the cell without the column separator (e.g. for header row). */
  withBorder?: boolean;
};

/**
 * Label column cell used by every invoice-detail table (Summary / Items /
 * Payments). Renders the user's role-coloured dot and their external_id
 * inside a `kLabelColumnWidth` column with a right border separator.
 */
export const UserLabelCell = ({
  externalId,
  role,
  onClick,
  className,
  align = 'center',
  withBorder = true,
}: Props): JSX.Element => (
  <div
    className={clsx(
      kLabelColumnWidth,
      'shrink-0 px-[13.5px] flex min-w-0',
      align === 'center' ? 'items-center' : 'items-start',
      withBorder && 'border-r-[0.5px] border-main-200',
      className
    )}
  >
    <div
      className={clsx(
        'flex items-center gap-x-f1 min-w-0',
        align === 'start' && 'h-[2lh]'
      )}
    >
      {role ? (
        <RoleColorDot role={role} />
      ) : (
        <div className="w-[14px] h-[14px] rounded-full shrink-0 bg-main-200" />
      )}
      {onClick ? (
        <button
          type="button"
          className="text-main text-xmd truncate hover:underline cursor-pointer"
          onClick={() => onClick(externalId)}
        >
          {externalId || '—'}
        </button>
      ) : (
        <span className="text-main text-xmd truncate">{externalId || '—'}</span>
      )}
    </div>
  </div>
);
